import { render, staticRenderFns } from "./FormPrivateFile.vue?vue&type=template&id=0f70c2f2&"
import script from "./FormPrivateFile.vue?vue&type=script&lang=js&"
export * from "./FormPrivateFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports